import { api } from "../adapters/api";
import { GigPreview } from "../hooks/models/GigPreview";

const resource: string = "api/v1";

export const getMyGigs = () => api.get(resource + "/gigs/employer", {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const getGigsAvailableToInvite = (candidateId: string) => api.get(resource + `/gigs/available-to-invite?candidateUserId=${candidateId}`, {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const getJobCategories = () => api.get(resource + "/categories", {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const getGigTitles = () => api.get(resource + "/gig-titles", {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const getGigTitlesByCategory = (categoryId: string) => api.get(resource + `/gig-titles?categoryId=${categoryId}`, {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const createGig = (formData: FormData) => api.post(resource + "/gigs", formData, {"Authorization": "Bearer " + localStorage.getItem("jwtToken")});

export const presignUpload = (extension: string) =>
    api.post(`api/v1/media/presign?extension=${extension}`, null, {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((res: any) => res.json());

export const uploadToR2 = async (uploadUrl: string, file: File): Promise<void> => {
    await fetch(uploadUrl, {
        method: "PUT",
        body: file,
        headers: { "Content-Type": file.type || "application/octet-stream" },
    });
};

export const createGigPresigned = (body: any, fileNames: string[], publicUrls: string[]) => {
    const params = new URLSearchParams();
    fileNames.forEach(n => params.append("fileNames", n));
    publicUrls.forEach(u => params.append("publicUrls", u));
    const query = params.toString() ? "?" + params.toString() : "";
    return api.post(resource + "/gigs/presigned" + query, JSON.stringify(body), {"Authorization": "Bearer " + localStorage.getItem("jwtToken"), "Content-Type": "application/json"});
};

export const updateGigPresigned = (gigId: string, body: any, fileNames: string[], publicUrls: string[]) => {
    const params = new URLSearchParams();
    fileNames.forEach(n => params.append("fileNames", n));
    publicUrls.forEach(u => params.append("publicUrls", u));
    const query = params.toString() ? "?" + params.toString() : "";
    return api.patch(resource + "/gigs/" + gigId + "/presigned" + query, JSON.stringify(body), {"Authorization": "Bearer " + localStorage.getItem("jwtToken"), "Content-Type": "application/json"});
};

export interface DurationOption {
    days: number,
    cost: number,
}

export interface JobPostingQuota {
    freeRemaining: number,
    freeDurationDays: number,
    durationOptions: DurationOption[],
    balance: number,
    hasActivePlan: boolean,
    includedJobPostsRemaining: number,   // -1 = nelimitat, 0 = niciunul (cade pe credite), n>0 = câte
}

export const getJobPostingQuota = (): Promise<JobPostingQuota> =>
    api.get(resource + "/gigs/posting-quota", {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const getGigDetails: any = (gigId: string) => api.get(resource + `/gigs/${gigId}`, {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const deleteGig = (gigId: string) => api.delete(resource + `/gigs/${gigId}`, {"Authorization": "Bearer " + localStorage.getItem("jwtToken")});

export const promoteGig = (gigId: string, durationDays?: number) => api.patch(resource + `/gigs/${gigId}/promote`, JSON.stringify({ durationDays }), {"Authorization": "Bearer " + localStorage.getItem("jwtToken"), "Content-Type": "application/json"});

export const getGigsByEvent = (eventId: string): Promise<GigPreview[]> =>
    api.get(resource + `/gigs/event/${eventId}/employer`, {"Authorization": "Bearer " + localStorage.getItem("jwtToken")}).then((data: any) => data.json());

export const updateGigDetails = (formData: FormData, gigId: string) => api.patch(resource + "/gigs/" + gigId, formData, {"Authorization": "Bearer " + localStorage.getItem("jwtToken")});

export interface UpdateGigRequest {
    gigTitle?: string
    location?: string,
    category?: string,
    rate?: string,
    rateType?: string,
    dateFrom?: string,
    dateTo?: string,
    cvNecessary?: boolean,
    videoNecessary?: boolean,
    description?: string,
    negotiableRate?: boolean,
    enabled?: boolean,
    jobType?: string,
    contractType?: string,
    experience?: string,
    confidentialRate?: boolean,
    workLocationType?: string,
    address?: string,
    latitude?: number,
    longitude?: number,
}